import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import type { MenuProps } from "antd";
import { Dropdown, Form, Modal, message } from "antd";
import { Col, DatePicker, theme, Drawer, Row, Select } from "antd";
import type { ColumnType, ColumnsType } from "antd/es/table";
import { Skeleton } from "antd";
import type { TableProps } from "antd/es/table";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TextArea from "antd/es/input/TextArea";

import Highlighter from "react-highlight-words";
import type { InputRef } from "antd";

import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SettingsIcon from "@mui/icons-material/Settings";

import type { FilterConfirmProps } from "antd/es/table/interface";

import axios from "axios";

import Globais, { logout, validateToken } from "../../components/Globais";
import { Box } from "@mui/material";

const Container = styled.section`
  width: 100%;
  height: 100%;

  display: grid;
  grid-template: 10% 90% / 100%;
`;
const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 5% 1fr 15%;

  justify-content: center;
  align-items: center;
`;
const ContainerTitulo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;
const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;
  grid-template: 10% 90% / auto;
`;
const H2 = styled.h2`
  color: ${Globais.CorAzulBackGround};
  text-align: center;
  font-size: 1.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.5rem;
`;
const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;
const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ContainerAdicionarCidade = styled.section`
  width: 100%;
  height: 100%;
  grid-column-start: 3;
  display: flex;

  justify-content: center;
  align-items: center;
`;

const defaultCidadeData = {
  nome: "",
  origem: 0,
  estadoId: 0,
};

interface DataType {
  id: number;
  nome: string;
  estadoId: number;
  origem: string;
  nomeEstado: string;
}

interface ValuesMaisCidade {
  nome: string;
  estadoId: number;
}

interface CollectionCreateFormPropsMaisCidade {
  open: boolean;
  onCreate: (valuesMaisCidade: ValuesMaisCidade) => void;
  onCancel: () => void;
}

type DataIndex = keyof DataType;
type MenuItem = Required<MenuProps>["items"][number];

export default function ViewGerenciarCidade() {
  const [isModalInserirCidadeVisible, setIsModalInserirCidadeVisible] =
    useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [nomesEstado, setNomesEstado] = useState([]);
  const [cidade, setCidade] = useState<any>();
  const [openEditarCidade, setOpenEditarCidade] = useState(false);
  const [openMaisCidade, setOpenMaisCidade] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [messageApi, contextHolder] = message.useMessage();
  const estadoId = useRef(0);
  const cidadeId = useRef(0);
  const searchInput = useRef<InputRef>(null);
  const emLote = useRef(0);
  const [tipo, setTipo] = useState(0);
  const [status, setStatus] = useState<number>(0);
  const [texto, setTexto] = useState<string>("");
  const [cidadeFormData, setCidadeFormData] = useState(defaultCidadeData);
  const [estado, setEstado] = useState<any | null>([{}]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  // if (cidadeFormData.estadoId === undefined && estado) {
  //   cidadeFormData.estadoId = estado[0].id;
  // }
  const options = estado.current;

  // useEffect(() => {
  //   const fetch = async () => {
  //     const Token = validateToken();
  //     if(Token){
  //      else{

  //       }
  //     }else{
  //       document.location.href = "/login"
  //     }
  //   }
  //   fetch();
  //   },[]);

  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        if (Token.nda === 0) {
          document.location.href = "/sempermissao";
        } else {
          const URL = `${Globais.DOMINIOBACK}/cidade`;
          const URLEstado = `${Globais.DOMINIOBACK}/estado`;

          try {
            const response = await axios.get(URL, {
              headers: {
                Authorization: Token.AuthStr,
              },
            });
            const responseEstado = await axios.get(URLEstado, {
              headers: {
                Authorization: Token.AuthStr,
              },
            });
            if (response) {
              const opcoesEstado = responseEstado.data.filter((Estado: any) => {
                if (Estado.origem === 0) {
                  Estado.value = Estado.id;
                  Estado.label = Estado.nome;
                  return Estado;
                } else {
                  return null;
                }
              });
              setNomesEstado(opcoesEstado);
              let ArrayNovo = response.data.filter((p: any) => {
                p.key = p.id;
                p.nomeEstado = p.nomeEstado;

                if (p.origem === 0) {
                  p.origem = "Multicotas";
                } else {
                  p.origem = "Usuário";
                }

                if (responseEstado) {
                  const ArrayEstado = responseEstado.data.filter((q: any) => {
                    q.nomeEstado = responseEstado.data.nome;
                    if (p.estadoId === q.id) {
                      p.nomeEstado = q.nome;
                    }
                    return q;
                  });
                }
                return p;
              });

              setCidade(ArrayNovo);
              setIsLoading(false);
            }
          } catch (error) {
            console.error("Erro ao buscar cidades:", error);
          }
        }
      }
    };
    fetchToken();
  }, []);

  const CollectionCreateFormMaisCidade: React.FC<
    CollectionCreateFormPropsMaisCidade
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openMaisCidade}
        title="Adicionar cidade"
        okText="Adicionar"
        cancelText="Cancelar"
        onCancel={onCancel}
        width={300}
        onOk={() => {
          form
            .validateFields()
            .then((valuesMaisCidade) => {
              form.resetFields();
              onCreate(valuesMaisCidade);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Form.Item
              name="nome"
              label="Cidade"
              style={{ width: 400 }}
              rules={[
                {
                  message: "Por favor insira o nome da cidade!",
                },
              ]}
            >
              <TextArea size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
            </Form.Item>
          </Row>
          <Row>
            <Form.Item name="nomeEstado" label="Estado" style={{ width: 400 }}>
              <Select
                defaultValue="Selecione um estado"
                size="large"
                style={{ width: 250 }}
                onChange={handleChange}
                options={nomesEstado}
              ></Select>
            </Form.Item>
          </Row>
        </Form>
      </Modal>
    );
  };

  const CollectionCreateFormEditarCidade: React.FC<
    CollectionCreateFormPropsMaisCidade
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openEditarCidade}
        title="Editar período"
        okText="Editar"
        cancelText="Cancelar"
        onCancel={onCancel}
        width={300}
        onOk={() => {
          form
            .validateFields()
            .then((valuesMaisPeriodo) => {
              form.resetFields();
              onCreate(valuesMaisPeriodo);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Form.Item
              name="nome"
              label="Cidade"
              style={{ width: 400 }}
              rules={[
                {
                  message: "Caso a data seja especial insira aqui!",
                },
              ]}
            >
              <TextArea
                defaultValue={cidade.current}
                size="large"
                autoSize={{ minRows: 1, maxRows: 1 }}
              />
            </Form.Item>
          </Row>
          <Row>
            <Form.Item name="nomeEstado" label="Estado" style={{ width: 400 }}>
              <Select
                defaultValue={estado.current}
                size="large"
                style={{ width: 250 }}
                onChange={handleChange}
                options={nomesEstado}
              ></Select>
            </Form.Item>
          </Row>
        </Form>
      </Modal>
    );
  };

  const adicionarCidades = async (valuesMaisCidade: any) => {
    const Token = validateToken();
    if (Token) {
      const URLCidade = `${Globais.DOMINIOBACK}/cidade`;
      let formDataCidade1 = {
        nome: valuesMaisCidade.nome,
        estadoId: estadoId.current,

        origem: 0,
      };

      try {
        const responseCriarCidade1 = await axios.post(
          URLCidade,
          formDataCidade1,
          {
            headers: { Authorization: Token.AuthStr },
          }
        );
        if (responseCriarCidade1) {
          success("Cidade adicionada com sucesso!");
          setTimeout(() => {
            document.location.reload();
          }, 2000);
        }
      } catch (error) {
        console.log("Não foi possível criar a cidade");
        error("Algo deu errado!");
      }
    } else {
      error("Favor fazer o login novamente!.");
      document.location.reload();
    }
  };

  const editarCidades = async (valuesMaisCidade: any) => {
    const Token = validateToken();

    if (Token) {
      if (valuesMaisCidade.cidade === undefined) {
        const URLCidade = `${Globais.DOMINIOBACK}/cidade/${cidadeId.current}`;
        let formDataCidade1 = {
          id: cidadeId.current,
          nome: valuesMaisCidade.nome,
          estadoId: estadoId.current,

          origem: 0,
        };
        console.log(formDataCidade1);

        try {
          const responseCriarCidade1 = await axios.put(
            URLCidade,
            formDataCidade1,
            {
              headers: { Authorization: Token.AuthStr },
            }
          );

          if (responseCriarCidade1) {
            success("Cidade editada com sucesso!");
            setTimeout(() => {
              document.location.reload();
            }, 2000);
          }
        } catch (error) {
          console.log("Não foi possível editar a cidade");
          error("Algo deu errado!");
        }
      }
    }
  };

  const handleChange = (id: string) => {
    // console.log(`selected ${id}`)
    const idSelect = (estadoId.current = +id);
  };

  const handleAdd = () => {
    setOpenMaisCidade(true);
  };

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };
  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const hideModal = () => {
    // setOpenExcluir(false);
  };
  const showModal = () => {
    alert("FUNÇÃO EM DESENVOLVIMENTO.");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (window.navigator.onLine === false) {
      setStatus(3);
      setTexto("Parece que você está sem conexão com a internet!");
      setTimeout(() => {
        setStatus(0);
      }, 3000);
    } else {
      const Token = validateToken();
      if (Token) {
        if (Token.nda === 1) {
          try {
            const URL = `${Globais.DOMINIOBACK}/cidade`;

            const response = await axios.post(URL, cidadeFormData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              setStatus(1);

              setTexto("Cidade incluído com sucesso!");
              setTimeout(() => {
                document.location.href = "/gerenciarCidade";
              }, 3000);
            }
          } catch (error) {
            console.log(error);
            switch (error.code) {
              case "ERR_NETWORK":
                setStatus(2);
                setTexto("Parece que tem algo errado com nosso serviço!");
                setTimeout(() => {
                  setStatus(0);
                }, 3000);
                break;
              case "ERR_BAD_RESPONSE":
                setStatus(2);
                setTexto("Parece que tem algo errado com nosso serviço!");
                setTimeout(() => {
                  setStatus(0);
                }, 3000);
                break;
            }
          }
        } else {
          document.location.href = "/";
        }
      } else {
        document.location.href = "/";
      }
    }
  };

  const items: MenuProps["items"] = [
    { key: "1", label: "Editar" },
    { key: "2", label: "Excluir" },
  ];

  const onClick: MenuProps["onClick"] = async ({ key }) => {
    const Token = validateToken();

    if (selectedRowKeys.length === 0 && emLote.current === 1) {
      error("Selecione um item!");
    } else {
      switch (key) {
        case "1":
          setOpenEditarCidade(true);

          break;
        case "2":
        // showModal();
      }
    }
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Cidade",
      dataIndex: "nome",
      key: "nome",
      width: "20%",
      align: "center",

      ...getColumnSearchProps("nome"),
    },
    {
      title: "Estado",
      dataIndex: "nomeEstado",
      key: "nomeEstado",
      width: "20%",
      align: "center",

      ...getColumnSearchProps("nomeEstado"),
    },
    {
      title: "Origem",
      dataIndex: "origem",
      width: "20%",
      align: "center",

      filters: [
        { text: "Multicotas", value: "Multicotas" },
        { text: "Usuário", value: "Usuário" },
      ],
      onFilter: (value: any, record) => record.origem.includes(value),
      defaultFilteredValue: ["Multicotas"],
      filterSearch: true,
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "20%",
      align: "center",

      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                // estado.current = row.id;
                cidade.current = row.nome;
                estado.current = row.nomeEstado;
                cidadeId.current = row.id;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];

  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const changeSelectEstadoOptionHandler = async (event: any) => {
    const estadoId = event.target.value;
    if (estadoId) {
      cidadeFormData.estadoId = estadoId;
    }
  };

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Container>
          <ContainerFiltro>
            <ContainerSeta>
              
            </ContainerSeta>
            <ContainerTitulo>
              <H2>Cidades</H2>
            </ContainerTitulo>
            <ContainerAdicionarCidade>
              <Button
                onClick={handleAdd}
                type="primary"
                style={{ marginBottom: 16, alignSelf: "left" }}
              >
                + Cidade
              </Button>
            </ContainerAdicionarCidade>
            <CollectionCreateFormMaisCidade
              open={openMaisCidade}
              onCreate={async function (
                valuesMaisCidade: ValuesMaisCidade
              ): Promise<void> {
                adicionarCidades(valuesMaisCidade);
              }}
              onCancel={function (): void {
                setOpenMaisCidade(false);
              }}
            />
          </ContainerFiltro>
          <ContainerLista>
            <Table
              columns={columns}
              dataSource={cidade}
              onChange={onChange}
              bordered
            />

            <CollectionCreateFormEditarCidade
              open={openEditarCidade}
              onCreate={async function (
                valuesMaisCidade: ValuesMaisCidade
              ): Promise<void> {
                editarCidades(valuesMaisCidade);
              }}
              onCancel={function (): void {
                setOpenEditarCidade(false);
              }}
            />
          </ContainerLista>
        </Container>
      )}
    </>
  );
}
